import React,{useState} from 'react'
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import authQueries from '../../queries/authQueries';
import { useFormContext } from '../../Context/FormContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Spin, } from 'antd';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import moment from 'moment';

const CallbackSave = ({current, setCurrent, navTab, setNavTab}) => {

  

  const [selectedLang, setSelectedLang] = useState('English')
  
  const [loading, setLoading] = useState(false);

  const [code, setCode] = useState('in');

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);


  const curDate = new Date()

  curDate.setDate(curDate.getDate()+10);

  const [selectedDate, setSelectedDate] = useState(curDate)

  const validationSchema = yup.object({
    ph: yup
      .string()
      .required('⚠ Phone number is required')
      // .matches(/^\d{10}$/, 'Phone number must be a 10-digit numeric string')
      .min(10, "⚠ Minimum number should be 10"),
    language: yup
      .string()
      .required("⚠ Language is required"),
});
    

const { register, reset, control, handleSubmit, formState: { errors }} = useForm({
    resolver: yupResolver(validationSchema),
});

const { formData, updateFormData, formResponse, updateFormResponse } = useFormContext();


const Compliant  = authQueries.useComplaintWithOutCodeMutation(

  (response) => {

    if(response?.message === "Success") {
      updateFormResponse(response.data)
      setIsButtonDisabled(false)
      setLoading(false)
      setNavTab(navTab + 1)
      setCurrent(current + 1)
    }
    else{
      setIsButtonDisabled(false)
      setLoading(false)
    }

  }
  
);

const onSubmit = async(data) => {

  setIsButtonDisabled(true)

  setLoading(true)

  if(formData?.ship_type === ''){

    formData.ship_type = null
    
  }

  console.log("DATA.DATESS is, ", moment(data.dates).format("YYYY-MM-DD HH:mm"))


  const Datas = {
    platform:"WEB", 
    ph : data.ph , 
    wnumber: data.wnum, 
    language: data.language ? data.language : selectedLang, 
    date: data.dates ? moment(data.dates).format("YYYY-MM-DD HH:mm"): moment(selectedDate).format("YYYY-MM-DD HH:mm"),
     ...formData
  } 

 const datavalues = {
     data : JSON.stringify(Datas),
 }

  Compliant.mutateAsync(datavalues);

}

const onCancel = (data) => {

  console.log(data)

  console.log("FormDATA <<>>", JSON.stringify(formData))

  setIsButtonDisabled(true)

  setLoading(true)

  if(formData?.ship_type === ''){

    formData.ship_type = null
    
  }

  const updatedData = { ...formData, callback: "NO", platform:"WEB", ph : '', wnumber: '', language:'', date: '' }

  if(formData?.ph != '' && formData?.wnumber && formData?.language && formData?.date){
    delete formData?.ph
    delete formData?.wnumber
    delete formData?.language
    delete formData?.date
  }

  const datavalues = {
    data : JSON.stringify(updatedData),
  }

  Compliant.mutateAsync(datavalues);

}



  return (
    
    <div>

      <Spin spinning={loading} size='large'>

        <div className="tab-pane verification-wrpr">
            
          <div className="row">
              
            <div className="col text-center mb-3">
                
              <div className="contact-details-msg">
                  
                <p className='text-left'>
                  Please provide your contact details below so that SHIPCONREP can contact you. Your employer will
                  not receive your details. If you change your mind about being contacted by SHIPCONREP, you can
                  click the Cancel button below.
                </p>
                  
                <p className="text-yellow text-center">It will not be shared with your employer.</p>
                
              </div>

            </div>

          </div>

          <div className="main-hding mt-0"><strong>Contact Details</strong></div>

            {/* <form onSubmit={handleSubmit(onSubmit)}> */}

              <div className="row">
              
                <div className="col-md-6">

                  <label>Phone Number<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>

                   {/* <span className="field-inline-icon phone"> */}

                  <Controller
                      name='ph'
                      control={control}
                      className="form-control h-[38px]"
                      render={({ field: { onChange } }) => (
                        <PhoneInput
                            enableSearch={true}
                            country={code}
                            onChange={(value, country, e, formattedValue) => {
                              setCode(country.countryCode)
                              onChange(value)
                            }}
                        /> 
                      )}
                      rules={{ required: true }}
                    />

                    {/* <input 
                      type="number" 
                      className="form-control" 
                      {...register('ph')} 
                    /> */}

                  {/* </span>  */}

                  {

                    errors?.ph &&

                      <div className='err' style={{marginBottom: 10}}>
                          {errors?.ph?.message}
                      </div>

                    }

                </div>

                <div className="col-md-6">
                  
                  <label>WhatsApp Number</label>

                  <span className="field-inline-icon whatsappphone">

                    {/* <input 
                      type="number" 
                      className="form-control"
                      {...register('wnum')}
                      name='wnum'  
                    /> */}

<Controller
                      name='wnum'
                      control={control}
                      className="form-control h-[38px]"
                      render={({ field: { onChange } }) => (
                        <PhoneInput
                            enableSearch={true}
                            country={code}
                            onChange={(value, country, e, formattedValue) => {
                              setCode(country.countryCode)
                              onChange(value)
                            }}
                        /> 
                      )}
                      rules={{ required: true }}
                    />

                  </span>

                  {

                    errors?.wnum &&

                      <div className='err' style={{marginBottom: 10}}>
                          {errors?.wnum?.message}
                      </div>

                    }

                </div>

              <div className="col-md-12">&nbsp;</div>

              <div className="col-md-6">

                <label>Preferred Language<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>

                <span className="field-inline-icon language">

                  <input 
                    type="text" 
                    defaultValue={selectedLang}
                    className="form-control"
                    {...register('language')}
                    name='language' 
                    maxLength={100}
                  /> 

                </span>

                {

                  errors?.language &&

                    <div className='err' style={{marginBottom: 10}}>
                        {errors?.language?.message}
                    </div>

                  }

              </div>

              <div className="col-md-6">

                <label>Preferred Date & Time for the call<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>

                <span className="field-inline-icon language">

                  {/* <input 
                    type="datetime-local" 
                    
                    className="form-control" 
                    {...register('dates')}
                    name='dates' 
                  /> */}

                  {/* <DatePicker
                    selected={selectedDate}
                    className="form-control"
                    minDate={curDate} 
                    style={{width: '100%',}}
                    placeholderText='DD-MM-YYYY , H:MM AM / PM'
                    onChange={date => setSelectedDate(date)}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="d-MM-yyyy , h:mm aa"
                  /> */}

                <Controller
                  control={control}
                  rules={{
                      required: true,
                  }}
                  render={({field: {onChange, value}}) => (
                    <DatePicker
                      selected={selectedDate}
                      className="form-control"
                      minDate={curDate} 
                      style={{width: '100%',}}
                      placeholderText='DD-MM-YYYY , HH:MM'
                      onChange={date => {
                        onChange(date)
                        setSelectedDate(date)}}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="dd-MM-yyyy , HH:mm"
                    />
                  )}
                  name="dates"
                />

                <span style={{marginLeft: 7, fontSize: 12, marginTop: 7 }}>UTC (24 hour format)</span>

                </span>

                {

                  errors?.dates &&

                    <div className='err' style={{marginBottom: 10}}>
                        {errors?.dates?.message}
                    </div>

                  }

              </div>

              <div className="row">

                <div className='col-md-6'>

                  <div className="d-grid gap-2 mt-4 mb-4">

                    <button className="btn btn-primary btn-informant"  onClick={() => onCancel()}>Cancel <i className="icon-close" style={{backgroundColor: 'red'}}></i></button>

                  </div>

                </div>

                <div className='col-md-6'>

                    <div className="d-grid gap-2 mt-4 mb-4">

                        <button className="btn btn-primary btn-informant" style={{background: '#0d6efd'}} type='submit' onClick={handleSubmit(onSubmit)}>Save & Submit<i className="icon-check"></i></button>

                    </div>

                </div>
  
              </div>
              
              {/* <div className="col-md-12">

                <div className="agreen-btn-wrpr  text-center mt-5 mb-5">

                  <button className="btn btn-primary btn-agree gotoStp3" type='submit'>Save <i className="icon-check"></i></button>

                  <button className="btn btn-primary btn-informant gotoStp1" onClick={() => onCancel()}>Submit <i className="icon-close"></i></button>

                </div>

              </div> */}
              
              </div>

            {/* </form> */}
          
        </div>

      </Spin>

    </div>

  )

}

export default CallbackSave